import { getFormatMessage } from '@/utils/utils'
import { message, Modal } from 'antd'
import React, { useState } from 'react'
import {
  AlarmItem,
  TemplateAlarmProps,
  TemplateReferenceItem
} from '../interface'
import { TemplateAlarmEdit } from './edit'
import { TemplateAlarmTable } from './table'
import { TemplateAlarmToolbar } from './toolbar'

export const TemplateAlarm: React.FC<TemplateAlarmProps> = (
  props: TemplateAlarmProps
) => {
  const { onDelete, onRefRelease } = props
  const formatMessage = getFormatMessage()
  const [editVisible, setEditVisible] = useState<boolean>(false)
  const [editItem, setEditItem] = useState<AlarmItem>({})
  const [editFormResult, setEditFormResult] = useState<boolean>(false)
  const [selected, setSelected] = useState<AlarmItem[]>([])
  const [references, setReferences] = useState<TemplateReferenceItem[]>([])

  const handleCreate = () => {
    setEditVisible(true)
    if (props.variables && props.variables.length > 0) {
      const variable = props.variables[0]
      setEditItem({
        variableId: variable.id,
        condition1: 1,
        condMethod: 0,
        condition2: 1,
        operate1: variable.dataType == 0 ? 1 : 0,
        operate2: 0,
        dead_value: 0,
        dead_type: 0
      })
    } else {
      setEditItem({})
    }
    setReferences([])
  }

  const handleEdit = (item: AlarmItem) => {
    const refs = props.onRefCheck?.([item])
    setReferences(refs || [])
    setEditItem(item)
    setEditVisible(true)
  }

  const hanldeDelete = (item: AlarmItem) => {
    onDelete?.([item])
  }

  const handleBatchDelete = async () => {
    if (!selected || selected.length <= 0) {
      return
    }
    const result = await onDelete?.(selected)
    if (result) {
      setSelected([])
    }
  }

  const validateFormData = (item?: AlarmItem): boolean => {
    const exist = props.data?.find(
      (x) => x.name == item?.name && x.id != item?.id
    )
    if (exist) {
      message.error(formatMessage({ id: 'app.template.alarm.existName' }))
      return false
    }
    return true
  }

  const handleEditFormValidate = (ok: boolean, item?: AlarmItem): boolean => {
    setEditFormResult(false)
    if (ok && validateFormData(item)) {
      setEditVisible(false)
      return true
    }
    return false
  }

  const handleRefRelease = (item: TemplateReferenceItem) => {
    if (!editItem) return
    const refs = onRefRelease?.([editItem], item)
    setReferences(refs || [])
  }

  return (
    <div>
      <TemplateAlarmToolbar
        {...props}
        selectable={selected.length > 0}
        onCreate={handleCreate}
        onBatchDelete={handleBatchDelete}
      />
      <TemplateAlarmTable
        {...props}
        selectable
        selectionType='checkbox'
        onEdit={handleEdit}
        onDelete={hanldeDelete}
        onSelect={setSelected}
      />
      <Modal
        visible={editVisible}
        onCancel={() => setEditVisible(false)}
        title={
          editItem?.id
            ? formatMessage({
                id: 'app.template.alarm.edit.title',
                parameters: { name: editItem.name }
              })
            : formatMessage({ id: 'app.template.alarm.toolbar.create' })
        }
        width={650}
        onOk={() => setEditFormResult(true)}
        okText={formatMessage({ id: 'app.modal.ok' })}
        cancelText={formatMessage({ id: 'app.modal.cancel' })}
        maskClosable={false}
        destroyOnClose={true}
      >
        <TemplateAlarmEdit
          {...props}
          item={editItem}
          formResult={editFormResult}
          references={references}
          onFormValidate={handleEditFormValidate}
          onRefRelease={handleRefRelease}
        />
      </Modal>
    </div>
  )
}
